import styles from './index.module.scss';

// Radio button options
const options = [
    'Immediately',
    'Within 1-3 months',
    'More than 3 months',
];

export default function Timeline({data, onChange}) {
    return (
        <div className={styles.container}>
            <h2>Timeline and Investment</h2>
            <div className={styles.radio}>
                <span>What is your expected timeline for setting up your business?</span>
                <div className={styles.options}>
                    {options.map((option, index) => (
                        <label key={index}>
                            <input type="radio" name="timeline" value={option} checked={data.timeline === option} onChange={() => onChange('timeline', option)}/>
                            {option}
                        </label>
                    ))}
                </div>
            </div>
        </div>
    )
}